export default __webpack_public_path__ + "static/media/a038-1.5c032cf4.svg";